<template>
  <v-container fluid>
    <v-row>
    <v-col lg="8" offset-lg="2" >
      <v-container >
        <v-row>
          <v-col cols="12" lg="4" md="4" sm="12" v-for="(data, index) in dataDes" :key="index" class="destination">
            <router-link :to="data.link">
              <v-card flat>
                <v-card-text>
                  <v-img
                    :src="require('../assets/images/destination/'+ data.image)"
                    lazy-src="../assets/images/before-show.jpg"
                    class="zoom-img"
                  />
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                  <h4 style="padding-top: 10px; text-align: center;" v-html="data.text" :class="styleFontBody"></h4>
                </v-card-text>
              </v-card>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
const axios = require("axios").default;
export default {
  name: "Destination",
  data() {
    return {
      lang: this.$route.params.lang,
      dataDes: [],
      styleFontResortName: {},
      styleFontTopic: {},
      styleFontBody: {}
    };
  },
  methods: {
    loadData() {
      let self = this;
      axios
        .get("/data/destination/summary-"+this.lang+".json")
        // eslint-disable-next-line no-unused-vars
        .then(function(res) {
          self.dataDes = res.data;
        });
    },
    loadStyle() {
      if (this.lang == 'th') { 
        this.styleFontResortName = {"th": true, "th-resort-name": true};
        this.styleFontTopic = {"th": true, "th-topic": true};
        this.styleFontBody = {"th": true};
      }
    }
  },
  mounted() {
    this.loadData();
    this.loadStyle();
  }
};
</script>

<style scoped>
.destination {
  transition-duration: 1s;
}
.destination:hover {
  /* box-shadow: #585858 10px 10px; */
  transform: scale(1.2);
  z-index: 99;
} 
a {
  text-decoration: none;
  color: #b2a358;
}
.zoom-img {
  transition-duration: 1s;
  overflow: hidden;
}

.zoom-img:hover {
  /* transform: scale(1.1); */
  transform: rotate(180);
}

</style>